export const NotificationCenterEvent = {
  NotiCenterPageView: 'noti_center_page_view',
  NotiCenterNotiClick: 'noti_center_noti_click',
} as const;

export type NotificationCenterEventType = typeof NotificationCenterEvent;

export interface NotificationCenterEventDataType {
  [NotificationCenterEvent.NotiCenterPageView]: {
    has_new_feature_update: boolean;
    notification_count: number;
  };
  [NotificationCenterEvent.NotiCenterNotiClick]: {
    noti_id: string;
    title: string;
    body: string;
    is_read: boolean;
    noti_page: string;
    noti_time: string;
    time_type: string;
    list_order: number;
  };
}
